export enum DxDiagnosisStepCodeEnum {
  DX_MIND = 'DX_MIND', // DXマインド
  BRANDING = 'BRANDING', // ブランディング
  DX_STRATEGY = 'DX_STRATEGY', // DX戦略立案
  BUSINESS_TRANSFORMATION = 'BUSINESS_TRANSFORMATION', // 既存事業変革
  NEW_VENTURES = 'NEW_VENTURES', // 新規事業開発
  BUSINESS_CONTINUITY = 'BUSINESS_CONTINUITY', // 事業継続
}
